import * as React from 'react'

import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'

import { ExternalIdentifierDisplayContainer } from './styles'

export const ExternalIdentifierDisplay = ({
  product,
  selectedVariant,
  order,
}) => {
  const {
    showExternalIdentifierInProductSummary,
    showOnlyProductSKU,
  } = useSiteConfig()
  const externalIdentifierDisplayLabel = i18n(
    'general.externalidentifierdisplay.text',
  )

  const externalIdentifier = showOnlyProductSKU
    ? product.externalIdentifier
    : selectedVariant
    ? selectedVariant.externalIdentifier
    : product.externalIdentifier

  if (externalIdentifier && showExternalIdentifierInProductSummary) {
    return (
      <ExternalIdentifierDisplayContainer order={order}>
        {`${externalIdentifierDisplayLabel}${externalIdentifier}`}
      </ExternalIdentifierDisplayContainer>
    )
  }

  return null
}
